import Vue from "vue";
import validations from "@/components/forms/validations";
import inputs from "@/components/forms/inputs";

for (const name in inputs) {
    Vue.component(name, inputs[name]);
}

export default {
    library: {
        // TODO: split out currency, decimal, integer
        supplios_number: {
            classification: "text",
            component: "FormInputNumber",
            slotProps: {
                component: ["locale", "currency", "minFractionDigits", "maxFractionDigits", "minSignificantDigits", "maxSignificantDigits"],
            },
        },
        // TODO: split out datetime_timezoned, date_timezoned, time_timezoned
        datetime: {
            classification: "text",
            component: "FormInputDateTime",
            slotProps: {
                component: ["locale", "timezone", "showTime", "timeOnly", "allowPast"],
            },
        },
        // TODO: split out select_multiple, select_single
        supplios_select: {
            classification: "select",
            component: "FormInputSelect",
            slotProps: {
                component: [
                    "multiple",
                    "url",
                    "apiMethod",
                    "requestConfig",
                    "optionsKey",
                    "optionLabel",
                    "optionValue",
                ],
            },
        },
        // same component as select, just for convenience
        autocomplete: {
            classification: "text",
            component: "FormInputSelect",
            slotProps: {
                component: [
                    "forceSelection",
                    "multiple",
                    "url",
                    "apiMethod",
                    "requestConfig",
                    "optionsKey",
                    "optionLabel",
                    "optionValue",
                    "excludeSuggestion",
                ],
            },
        },
        boolean: {
            classification: "checkbox",
            component: "FormInputBoolean",
            slotProps: {
                component: ["iconOn", "iconOff", "labelOn", "labelOff"],
            },
        },
        supplios_url: {
            classification: "text",
            component: "FormInputURL",
        },
        component: {
            classification: "component",
            component: "FormInputComponent",
            slotProps: {
                component: ["componentName"],
            },
        },
    },
    slotProps: {
        component: ["meta"],
    },
    rules: {
        ...validations.rules,
    },
    locales: {
        en: {
            ...validations.messages,
        },
    },
};
